import React, { useEffect, useRef, useState } from 'react';
import Header from '../../../components/header';
import Layout from '../../../components/layout';
import { AgGridReact } from 'ag-grid-react';
import Icon from '../../../components/icons';
import Drawer from '../../../components/Drawer';
import { Dropdown, Menu } from '../../../components/Dropdown';
import Button from '../../../components/elements/button';
import { DATE_FORMAT, PAGE_SIZE } from '../../../_common/constant';
import Pagination from '../../../components/pagination';
import Search from '../../../components/search';
import { downloadExcel, downloadPDF, showLocalDate } from '../../../_common/functions';
import Loader from '../../../components/loader';
import Filters from '../../../components/filters';
import { filterConfigType, Option } from '../../../_config/types';
import { titleCell } from '../../../components/elements/function';
import AddSageAssestGM from './AddSageAssestGM';
import toast from 'react-hot-toast';
import { useSagesApi } from '../../../store/api/hooks/sageApiHook';
import { useDialog } from '../../../store/api/hooks/dialogHook';
import AddSageAssetExpensesMapping from './AddSageAssetExpensesMapping';

const SageAssetsExpensesMapping: React.FC = () => {
    const sageApi: any = useSagesApi();
    const createDrawerRef: any = useRef();
    const [currentPage, setCurrentPage] = useState<number>(1);
    const [searchParam, setSearchParam] = useState<string>('');
    const [totalRecords, setTotalRecords] = useState<number>(0);
    const filtersRef: any = useRef();
    const [filters, setFilters] = useState<any>({});
    const [rowData, setrowData] = useState<any>(null);
    const [assetSubGroupName, setAssetSubGroupName] = useState<any[]>([]);
    const [editData, setEditData] = useState<any>(null);
    const [filtersApplied, setFiltersApplied] = useState<any>({ generalFilter: false });
    const [filtersInitialized, setFiltersInitialized] = useState<boolean>(false);

    // Load filters from localStorage on component mount
    useEffect(() => {
        const savedFilters = localStorage.getItem('sageAssetsExpensesMappingFilters');
        if (savedFilters) {
            try {
                const parsedFilters = JSON.parse(savedFilters);
                setFilters(parsedFilters);
            } catch (error) {
                console.error('Error parsing saved filters:', error);
                setFilters({});
            }
        } else {
            setFilters({});
        }
        setFiltersInitialized(true);
    }, []);

    // Save filters to localStorage when filters change
    useEffect(() => {
        if (Object.keys(filters).length > 0) {
            localStorage.setItem('sageAssetsExpensesMappingFilters', JSON.stringify(filters));
        }
    }, [filters]);
    const addNewAssetGroupMasterRef: any = React.createRef<HTMLButtonElement>();
    const createAssetGroupMasterRef: any = useRef();
    const filterConfig: filterConfigType[] = [
        { name: 'Group Name', type: 'dropdown', key: 'assetSubGroupName', options: assetSubGroupName ? assetSubGroupName : [] },
    ];
    const { confirm } = useDialog();

    const onGridReady = (params: any) => {
    };
    const onRowClicked = (event: any) => {
        if (!event.event.target.closest('input[type="checkbox"]')) {
            event.node.setSelected(false);
        }
    };
    const columnDefs = [
        { headerCheckboxSelection: true, checkboxSelection: true, width: 50, headerClass: 'bg-[#f0f0f0]' },
        { headerName: 'Group Code', field: 'assetSubGroupCode', headerClass: 'bg-[#f0f0f0]', width: 200, cellRenderer: titleCell },
        { headerName: 'Group Name', field: 'assetSubGroupName', headerClass: 'bg-[#f0f0f0]', minWidth: 200, flex: 1, cellRenderer: titleCell },
        { headerName: 'Expense Account', field: 'accountName', headerClass: 'bg-[#f0f0f0]', minWidth: 200, flex: 1, cellRenderer: titleCell },
        {
            headerName: 'Action',
            field: 'actions',
            headerClass: 'bg-[#f0f0f0] text-center',
            pinned: 'right',
            width: 90,
            cellRenderer: (params: any) => {
                return (
                    <div className='relative h-full w-full flex items-center justify-center'>
                        <Icon name='threedote' size={1.25} className='text-[#000000]' onClick={(e: any) => {
                            e.stopPropagation();
                            e.preventDefault();
                            const dropdown: any = document.querySelector('.action-dropdown');
                            if (dropdown) {
                                dropdown.focus();
                            }
                            return false;
                        }} />
                        <select
                            onChange={(e) => {
                                handleActionChange(e, params);
                                e.target.selectedIndex = -1;
                            }}
                            onFocus={(e) => {
                                e.target.selectedIndex = -1;
                            }
                            }
                            className="action-dropdown"
                            style={{
                                position: "absolute",
                                top: 0,
                                left: 0,
                                width: "100%",
                                height: "100%",
                                opacity: 0,
                                cursor: "pointer",
                            }}
                        >
                            <option value="edit">Edit</option>
                            {/* <option value="delete">Delete</option> */}
                        </select>
                    </div>
                )
            }
        },
    ];

    const handleActionChange = (e: any, params: any) => {
        const action = e.target.value;
        const rowData = params.data;

        switch (action) {
            case "edit":

                setEditData(rowData);
                addNewAssetGroupMasterRef.current.open();
                console.log("Edit action for row: ", rowData);
                break;
            default:
                console.log("Unknown action: ", action);
                break;
        }
        e.target.selectedIndex = -1;
    };

    const GetAssetSubGroupList = () => {
        const payload: any = {
            pageSize: PAGE_SIZE,
            pageNumber: currentPage,
            searchParam: searchParam,
        };

        if (filters) {
            Object.keys(filters).map((key: any) => {
                if (filters[key]) {
                    payload[key] = filters[key];
                }
            });
        }
        setrowData(null);
        /* sageApi.getAssetSubGroupList(payload, (resp: any) => {
            setrowData(resp.assetSubGroupList ? resp.assetSubGroupList : []);
            setTotalRecords(resp.totalRecord);
            let assetsSubGroupList: any = [];
            resp.assetSubGroupList.map((assetSubGroupList: any) => {
                assetsSubGroupList.push({
                    label: assetSubGroupList.assetSubGroupName,
                    value: assetSubGroupList.assetSubGroupName,
                    data: assetSubGroupList
                });
            });
            setAssetSubGroupName(assetsSubGroupList);
        }, (error: any) => {
            console.log('error =>', error);
            toast.error(error);
        }); */
        sageApi.getSageAssetGroupExpenseAccountMappingList(payload, (resp: any) => {
            const list = Array.isArray(resp?.sageAssetGroupExpenseAccountMappingList) ? resp.sageAssetGroupExpenseAccountMappingList : [];
            console.log('Asset Sub Group List:', list);


            setrowData(list);
            setTotalRecords(resp.totalRecord);

            const assetsExpenseGroupList = list.map((item: any) => ({
                label: item.assetSubGroupName,
                value: item.assetSubGroupName,
                data: item
            }));

            setAssetSubGroupName(assetsExpenseGroupList);
        }, (error: any) => {
            console.log('error =>', error);
            toast.error(error);
        });

    };

    // Call GetAssetSubGroupList only after filters are initialized
    useEffect(() => {
        if (filtersInitialized) {
            GetAssetSubGroupList();
        }
    }, [filters, filtersInitialized]);

    useEffect(() => {
        if (filtersInitialized) {
            GetAssetSubGroupList();
        }
        
        const hasActiveFilters = filterConfig.some((filter) => filters[filter.key]);
        setFiltersApplied({
            generalFilter: hasActiveFilters,
        });
    }, [currentPage, searchParam, filters]);


    return (
        <Layout>
            <Header title="Sage Asset Expenses Mapping List" back="/settings" >
                <Header.Right>
                    <Drawer _ref={addNewAssetGroupMasterRef} onClose={() => {
                        setEditData(null);
                        createAssetGroupMasterRef?.current?.reset()
                    }} outsideClose={false}>
                        <Drawer.Button>
                            <Button>{editData ? 'Edit' : 'Create'} New Asset Expenses Mapping</Button>
                        </Drawer.Button>
                        <Drawer.Content title={editData ? 'Edit Asset Expenses Mapping' : 'Create New Asset Expenses Mapping'} className='!w-[39.563rem]'>
                            <AddSageAssetExpensesMapping _ref={createAssetGroupMasterRef} editData={editData} onCreate={() => {
                                setEditData(null);
                                GetAssetSubGroupList();
                                addNewAssetGroupMasterRef?.current?.close();
                            }} onCancel={() => {
                                setEditData(null);
                                addNewAssetGroupMasterRef?.current?.close();
                            }} />
                        </Drawer.Content>
                    </Drawer>
                </Header.Right>
            </Header>
            <div className='flex items-center justify-between pl-5 pr-3 border-b border-gray-200 h-[3.75rem]'>
                <Pagination
                    perPage={PAGE_SIZE}
                    totalRecords={totalRecords}
                    onPageChange={setCurrentPage}
                    currentPage={currentPage}
                />
                <Search onSearch={setSearchParam} placeholder='Search by Group code'/>
            </div>
            <div className='bg-[#FAFAFA] w-full'>
                <div className='flex gap-4 px-5 py-2 items-center'>
                    <Button theme='light' onClick={() => filtersRef.current.showModal()}>Filter <Icon name='filter' size={1.40} className={filtersApplied.generalFilter ? "text-blue-700" : ""} /></Button>
                    <p className='text-primary font-semibold text-sm cursor-pointer' onClick={() => {
                        setFilters({});
                        localStorage.removeItem('sageAssetsExpensesMappingFilters');
                        setFiltersApplied({ generalFilter: false });
                        setCurrentPage(1);
                    }} >Clear Filters</p>
                </div>
                <div className="ag-theme-alpine px-4 w-full h-1/2">
                    <AgGridReact
                        columnDefs={columnDefs as any} // Pass columnDefs
                        rowData={rowData || []} // Pass rowData
                        rowSelection="multiple"
                        onGridReady={onGridReady}
                        pagination={false}
                        domLayout="autoHeight"
                        onRowClicked={onRowClicked}
                        loadingOverlayComponent={Loader}
                        noRowsOverlayComponent={() => (
                            <div className="flex items-center justify-center h-full">
                                <div className="text-center text-gray-500">
                                    <div className="text-lg font-medium">No Data Found</div>
                                </div>
                            </div>
                        )}
                    />
                </div>
            </div>
            <Filters _ref={filtersRef} config={filterConfig} filters={filters} onUpdate={setFilters} />
        </Layout>
    );
};
export default SageAssetsExpensesMapping;